var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","color":"primary","open-delay":"100"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"ma-0 mr-2",attrs:{"text":"","icon":"","height":"38","width":"28"},on:{"click":function($event){return _vm.fullscreen()}}},on),[_c('v-icon',{attrs:{"color":"#767676"}},[_vm._v(_vm._s(_vm.icon))])],1)]}}])},[_vm._v(" "),_c('span',{staticStyle:{"font-size":"9px"}},[_vm._v(_vm._s(_vm.$t("Fullscreen")))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f99b4c3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/NavBar/Fullscreen.vue
// module id = null
// module chunks = 